import { render, staticRenderFns } from "./admissionExpensesDetail.vue?vue&type=template&id=cca599bc&scoped=true"
import script from "./admissionExpensesDetail.vue?vue&type=script&lang=js"
export * from "./admissionExpensesDetail.vue?vue&type=script&lang=js"
import style0 from "./admissionExpensesDetail.vue?vue&type=style&index=0&id=cca599bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cca599bc",
  null
  
)

export default component.exports